import React, { useContext, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import { getPriceChangeWeekLvlData } from 'gqlQueries/priceChangeQueries';
import { priceChangeSalesTrendChartParser } from 'parser/priceChangeDataParser';
import { UserContext } from 'contexts/ConfigContext';

const errorMessage: string = 'Something went wrong!';

function useFetchPriceChangeTrendsChart() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);

    const [fetchPriceChangeTrendsChartData] = useLazyQuery(getPriceChangeWeekLvlData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceChangeWeekLvlData } = payload;
            //if data present parse it
            if (getPriceChangeWeekLvlData && 'data' in getPriceChangeWeekLvlData) {
                const parsedData = priceChangeSalesTrendChartParser(getPriceChangeWeekLvlData?.data, appConfig);
                setData(parsedData);
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        setLoading,
        fetchPriceChangeTrendsChartData: (variables: any) => {
            setData(null);
            setLoading(true);
            setError(null);
            fetchPriceChangeTrendsChartData(variables);
        },
    };
}

export { useFetchPriceChangeTrendsChart };
